import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=5ebacbf6&scoped=true&ts=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=5ebacbf6&scoped=true&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebacbf6"]])

export default __exports__